// extracted by mini-css-extract-plugin
export default {"editor":"provinceSelector_editor__0iKZa","select":"provinceSelector_select__kS08u","chips":"provinceSelector_chips__zV+z-","removeBadge":"provinceSelector_removeBadge__1h0bk"};